import * as React from "react";

import { useLocalization } from "@shared-ui/localization-context";
import { PropertyFilteredReviews } from "@shared-ui/lodging-reviews";

import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { ComponentProps } from "typings/flexFramework/FlexComponent";

import { UitkFullscreenDialog, UitkDialogContent } from "uitk-react-dialog";
import { UitkToolbar, UitkToolbarProps, ToolbarType } from "uitk-react-toolbar";

const WrappedPropertyFilteredReviews = PropertyBexApiWrapper(PropertyFilteredReviews);

export const PropertyFilteredReviewsDialog: React.FC<ComponentProps & { onClose: () => void }> = ({
  context,
  onClose,
}) => {
  const { formatText } = useLocalization();

  const toolbarProps: UitkToolbarProps = {
    type: ToolbarType.CLOSE,
    action: onClose,
    header: formatText("reviews.dialog.title"),
    iconLabel: formatText("reviews.dialog.close.a11yLabel"),
  };

  return (
    <UitkFullscreenDialog strictFullscreen={true} wideContent={true}>
      <UitkToolbar {...toolbarProps} />
      <UitkDialogContent>
        <WrappedPropertyFilteredReviews context={context} />
      </UitkDialogContent>
    </UitkFullscreenDialog>
  );
};
